import { Autoplay } from 'swiper';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import React, { Dispatch, SetStateAction } from 'react'
import { Card, CardContent, CardMedia, useMediaQuery } from '@mui/material';

import { IProducto } from '../../../Interfaces/IProductos';

import stylesModule from '../styles/stylesInicio.module.css';


interface Props {
  productos: IProducto[];
  isCompras: boolean;
  setDialogOpen: Dispatch<SetStateAction<boolean>>;
  setIsCompras: Dispatch<SetStateAction<boolean>>;
  setProduct: Dispatch<SetStateAction<IProducto>>;
}

const SwiperProductosAdquiridos = ({productos, isCompras, setDialogOpen, setIsCompras, setProduct} : Props) => {

  const tabletCol = useMediaQuery('(max-width: 650px)');
  const matches2 = useMediaQuery('(max-width: 1025px)');
  const matches3 = useMediaQuery('(max-width: 1250px)');

  const navigate = useNavigate(); 

  return (
    <Swiper
      slidesPerView={tabletCol ? 1 : matches2 ? 2 : matches3 ? 3 : 4}
      spaceBetween={30}
      className="mySwiper"
      autoplay={{
        delay: 4000,
        disableOnInteraction: false,
      }}
      style={{ margin: 'auto' }}
      modules={[Autoplay]}
    >
      {productos &&
        productos.length > 0 &&
        productos.map(
          (material: IProducto, index: number) => (
            <SwiperSlide
              style={{
                marginBottom: '2rem',
              }}
              key={String(material.tipoPagoID)}
              className='swipper-slide-custom'
            >
              <Card
                className="px-2 max-w-[300px] m-auto"
                style={{ boxShadow: 'none' }}
                sx={{ margin: '2rem 0' }}
                onClick={() => {
                  if (
                    material.subTipo === 'Programa' ||
                    material.subTipo === "Mini Curso"
                  ) {
                    navigate(`/producto/${material.tipoPagoID}`);
                  } else {
                    setDialogOpen(true);
                    if (isCompras) {
                      setIsCompras(true);
                    }
                    setProduct(material);
                  }
                }}
              >
                <div onDragStart={(e) => e.preventDefault()}>
                  <CardMedia
                    className={stylesModule.media}
                    component="img"
                    src={material.portada}
                    alt={material.titulo || 'Producto'}
                    style={{
                      boxShadow: '0px 15px 15px -5px grey',
                      height: '200px',
                      borderRadius: '15px',
                      cursor: 'pointer',
                      maxWidth: '300px',
                      margin: 'auto',
                    }}
                  />
                  <CardContent>
                    <div>
                      <p className="m-0 font-bold text-[#E8A817]">
                        {material.subTipo}
                      </p>
                    </div>
                    <div
                      className={`hind`}
                      style={{ fontSize: '1rem', height: '46px' }}
                    >
                      <p
                        className="m-0 flex items-center font-bold text-base"
                        style={{ height: '30px' }}
                      >
                        {material.titulo} <br />
                      </p>
                      {/* <p className="title m-0" style={{ color: '#04A41E' }}>
                      $ {material.precio} dólares
                    </p> */}
                    </div>
                  </CardContent>
                </div>
              </Card>
            </SwiperSlide>
          ),
        )}
    </Swiper>
  )
}

export default SwiperProductosAdquiridos